// extracted by mini-css-extract-plugin
export default {"root":"_ktGYwVwDexi_GyY5jl_","rootUnderSubheader":"h9tZyIJWxmcM09782YSu"};